import { Component } from '@angular/core';
import {trackChangesIcon} from '@progress/kendo-svg-icons';

@Component({
  selector: 'app-release-notes',
  template: `
    <div style="max-height: 500px; overflow-y: auto; padding: 10px;">
      <markdown [src]="'/assets/release_notes.md'"></markdown>
    </div>
  `,
  styles: [`
    :host ::ng-deep h1 { font-size: 1.5rem; margin-top: 0; }
    :host ::ng-deep ul { padding-left: 20px; }
  `]
})
export class ReleaseNotesComponent {
  public icon = trackChangesIcon;
}


